import React, { useEffect, useState } from "react";
import { NavigationalButtons } from "./CreateCourseWizard";
import { Formik, Form } from "formik";
import useAxios from "axios-hooks";
import ChoiceGroup from "../../../../Forms/ChoiceGroup";
import DropDown from "../../../../Forms/DropDown";
import { Dropdown, Spinner } from "@fluentui/react";

const CategoryStep = ({ courseId, nextOnClick, prevOnClick }) => {
    const [selectedTags, setSelectedTags] = useState(null);
    const [{ loading: submitting }, postForm] = useAxios(
        {
            url: `/courses/${courseId}/category`,
            method: "put",
        },
        { manual: true }
    );

    const [{ data: course, loading: loadingCourse }] = useAxios(`courses/${courseId}`);
    const [{ data: categories, loading: loadingCategories }] = useAxios('courses/con-categories');
    const [{ data: tags, loading: loadingTags }] = useAxios('courses/con-tags');

    useEffect(() => {
        course && setSelectedTags(course.tags.map((t) => t.id));
    }, [course]);

    if (!selectedTags || loadingCategories || loadingTags || loadingCourse)
        return <Spinner className="absolute-center" label="Loading..." />;

    const navCategoryOptions = [
        { key: '', text: 'Select' },
        { key: 1, text: 'Money Management' },
        { key: 2, text: 'Credit and Debt' },
        { key: 3, text: 'Wealth Building' },
        { key: 4, text: 'Protection' },
        { key: 5, text: 'Milestones and Major Purchases' },
        { key: 6, text: 'Career' },
        { key: 7, text: 'Education' },
        { key: 8, text: 'Other' },
    ];

    return (
        <div>
            <Formik
                initialValues={{
                    conCategoryId: course.categoryId,
                    navCategoryId: course.navCategoryId,
                    conTagIds: selectedTags,
                    teaserTag_CONTagID: course.teaserTagId,
                }}
                onSubmit={async (values) => {
                    const result = await postForm({ data: values });

                    if (!result.isAxiosError) {
                        nextOnClick();
                    }
                }}
            >
                {({ setFieldValue, values }) => (
                    <Form style={{width: 500}}>
                        <ChoiceGroup
                            label="Category"
                            name="conCategoryId"
                            options={
                                categories &&
                                categories.map((category) => ({
                                    key: category.id,
                                    text: category.name,
                                }))
                            }
                        />
                        
                        <DropDown
                            multiSelect
                            label="Tags"
                            name="conTagIds"
                            className="mt20"
                            options={
                                tags &&
                                tags.map((tag) => ({
                                    key: tag.id,
                                    text: tag.name,
                                }))
                            }
                            handleChangeMultiSelect={(event, option, keys) => {
                                setSelectedTags(keys);
                                setFieldValue("conTagIds", keys);
                            }}
                            calloutProps={{
                                styles: {
                                  calloutMain: {
                                    maxHeight: 300, // Set max height for dropdown (300px here)
                                    overflowY: 'auto', // Make dropdown scrollable
                                  },
                                },
                              }}
                              styles={{
                                callout: {
                                  maxHeight: 300, // Set the max height for the dropdown
                                  overflowY: 'auto', // Enable scrolling if content exceeds height
                                },
                              }}
                        />
                        <ChoiceGroup
                            label="Teaser Tag to Display*"
                            name="teaserTag_CONTagID"
                            className="mt20"
                            options={
                                tags &&
                                tags
                                    .filter((t) => selectedTags.includes(t.id))
                                    .map((t) => ({
                                        key: t.id,
                                        text: t.name,
                                    }))
                            }
                        />

                        <Dropdown
                            label="Nav Category"
                            className="mt20"
                            selectedKey={values.navCategoryId}
                            options={navCategoryOptions}
                            onChange={(event, option) =>
                                setFieldValue("navCategoryId", option.key)
                            }
                        />
                        <NavigationalButtons
                            loading={submitting}
                            onNextProps={{ type: "submit", text: "Save and Continue" }}
                            onPrevHandler={prevOnClick}
                        />
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default CategoryStep;
